import styled from "styled-components";

import { MainContainer } from "@/shared/layout/Layout";

export const StyledMainContainer = styled(MainContainer)`
    padding: 16px 16px 10px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
